import type { EntityConfig } from '../types'

export const posRecipeEntity: EntityConfig = {
  id: 'pos-recipe',
  displayName: 'Recipe',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'draft', label: 'Draft' },
      { value: 'archived', label: 'Archived' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'draft', label: 'Draft', color: 'warning' },
      { value: 'archived', label: 'Archived', color: 'neutral' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      draft: ['draft'],
      archived: ['archived'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    menuCategory: { type: 'string_array', urlKey: 'category' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['status', 'menuCategory'],
}
